/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Boards/Content/Content/BoardItem/IconAndTitle/AssignedToMe/Content"
  
}) {
let myTasksCountAggregateCountValueData = fromData.useDataValue({ viewPath,
context: 'my_tasks_count',
path: 'aggregate.count',
})
let constantData = ' assigned to you'
let aggregateData = fromAggregate.join(myTasksCountAggregateCountValueData, constantData)
let myTasksCountAggregateCountValueData1 = fromData.useDataValue({ viewPath,
context: 'my_tasks_count',
path: 'aggregate.count',
})
let constantData1 = 0
let aggregateData1 = fromAggregate.isGreaterThan(myTasksCountAggregateCountValueData1, constantData1)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<fromFlow.When is={aggregateData1}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral500}
 data="my_tasks_count.aggregate.count"
 data="' assigned to you'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
 data="my_tasks_count.aggregate.count"
 data={0}
 aggregate="/Data/aggregate.js isGreaterThan"
/>
</fromFlow.When>
{children}
</React.Fragment>)
}